angular.module('wbDashboard').controller('PlanningRiskScoreControllerAurea',
    ['$scope', '$q', 'User', 'Milestone', 'RiskScore', 'PlanService', 'Message', 'Misc', 'PlanningService', 'ThinkingService',
function ($scope, $q, User, Milestone, RiskScore, PlanService, Message, Misc, PlanningService, ThinkingService) {

    $scope.pageData = {
        updatingMilestones: false,
        sending: false,
        thinking: false,
        detailRefreshed: false
    };
    $scope.forms = {};
    $scope.pages = ['profile', 'risk-score', 'milestones', 'confirm'];

    $scope.options = {};
    $scope.options.income = Misc.income_levels;

    $scope.riskData = {
        riskScore: null, //so defaults to middle of slider
        riskScoreOriginal: null,
        riskScoreRecommended: null,
    };

    $scope.milestoneChoices = [];

    $scope.recommendationSlug = $scope.$stateParams.recommendationSlug ? $scope.$stateParams.recommendationSlug : PlanningService.riskInfo.slug;

    $scope.showLoading = function() {
        // ThinkingService.open($scope, "risk-score", {thinking:"Calculating your risk score", complete:"Complete!"});
    };

    $scope.showLoading();
    User.retrieveDetail(true).then(function() {
        $scope.pageData.detailRefreshed = true;
        // ThinkingService.close(true, 'risk-score');
    });

    $scope.$watch(User.getDetail, function(detail) {
        if (detail && $scope.pageData.detailRefreshed) {
            $scope.riskData.riskScoreOriginal = detail.risk_score.chosen * 1;
            $scope.riskData.riskScoreRecommended = detail.risk_score.recommended * 1;
            if (!$scope.riskData.riskScore) {
                $scope.riskData.riskScore = detail.risk_score.recommended * 1;
            }
        }
    });

    $scope.$watch(function() { return User.getMilestones(); }, function(milestones) {
        if (milestones) {
            $scope.setUpdatableMilestones();
        }
    });

    $scope.riskPortfolios = null;
    RiskScore.retrievePortfolios();
    $scope.$watch(function() { return RiskScore.getPortfolios(); }, function(portfolios) {
        if (portfolios) {
            $scope.riskPortfolios = angular.copy(portfolios);
        }
    });

    $scope.hasSelectedMilestones = function() {
        return !!$scope.milestoneChoices.find(m=>m.selected);
    };

    $scope.updateRiskScore = function() {
        var riskScore = $scope.riskData.riskScore.toFixed(1);
        $scope.pageData.sending = true;

        $q.when(1).then(function() {
            if ($scope.riskData.riskScore === $scope.riskData.riskScoreOriginal) {
                return User.getDetail().risk_score;
            } else {
                return User.updateRiskScore(riskScore);
            }

        }).then(function(response) {
            User.retrieveDetail(true);

            return $scope.setUpdatableMilestones();

        }).then(function() {
            if ($scope.milestoneChoices.length) {
                $scope.goNextPage();
            } else {
                $scope.$state.go('base.profile.planning');
            }
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.setUpdatableMilestones = function() {
        var milestones = User.getMilestones();

        $scope.pageData.updatingMilestones = true;

        let promises = [], milestoneChoices = [];
        angular.forEach(milestones, function(ms) {
            if (ms.type === "cash" || ms.allocation.allocation_slug) { return; }

            var msClass = Milestone.setMilestoneUpdateFromObject(ms);
            promises.push(Milestone.getGlideRecommend(msClass));
            milestoneChoices.push(msClass);
        });

        $scope.milestoneChoices = milestoneChoices;

        return $q.all(promises).finally(function() {
            $scope.pageData.updatingMilestones = false;
        });

    };

    $scope.updateMilestoneAllocations = function() {

        $scope.pageData.sending = true;

        let promises = [];
        angular.forEach($scope.milestoneChoices, function(ms) {
            if (!ms.selected) { return; }

            var data = ms.allocation.recommendation;
            promises.push(PlanService.user.setMilestoneAllocation(ms.id, data));
        });

        $q.all(promises).catch(function(err) {
            Message.set({
                "type": "danger",
                "text" : "There was an issue updating your milestones, please refresh to try again or contact support@axosinvest.com if you have any questions.",
            });
            throw err;
        }).then(function() {
            User.retrieveAllMilestones(true);
            $scope.$state.go('base.profile.planning');
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };

    $scope.goNextPage = function(nextPage) {
        var currentPage = $scope.$stateParams.page;
        var pageIndex = $scope.pages.indexOf(currentPage);

        //after page actions for current page
        switch (currentPage) {
            case 'risk-score':
                if ($scope.$stateParams.riskReturnTo) {
                    $scope.$state.go($scope.$stateParams.riskReturnTo);
                    return;
                }
                break;
        }

        if (!nextPage) {
            nextPage = $scope.pages[pageIndex + 1];
        }

        nextPage = $scope.beforePage(nextPage);

        if (nextPage) {
            $scope.goToPage(nextPage);
        }

    };

    $scope.beforePage = function(page) {
        var nextPage = page;
        var pageIndex = $scope.pages.indexOf(page);

        switch (nextPage) {
            default:
                break;
        }
        if (nextPage !== page) {
            nextPage = $scope.beforePage(nextPage);
        }
        return nextPage;
    };

    $scope.goToPage = function(page, options = {}) {
        if (page) {
            return $scope.$state.go('.', {page: page}, options);
        }
    };

    if ($scope.$stateParams.page !== 'risk-score') {
        $scope.goToPage('risk-score', {location: 'replace'});
    }

    var transitionDeregisterHook;
    transitionDeregisterHook = $scope.$transitions.onBefore({ to: 'base.planning.risk-score' }, function(trans) {
    });
    $scope.$on('$destroy', function() {
        transitionDeregisterHook();
    });

}]);
